import { render, staticRenderFns } from "./hpProducts.vue?vue&type=template&id=beedab4a&scoped=true&"
import script from "./hpProducts.vue?vue&type=script&lang=js&"
export * from "./hpProducts.vue?vue&type=script&lang=js&"
import style0 from "./hpProducts.vue?vue&type=style&index=0&id=beedab4a&scoped=true&lang=css&"
import style1 from "./hpProducts.vue?vue&type=style&index=1&id=beedab4a&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "beedab4a",
  null
  
)

export default component.exports